import React, { useState, useEffect } from 'react';
import Navbar from '../components/Navbar';
import { useSelector, useDispatch } from 'react-redux';
import ReduxAxios from '../redux/actions';
import axios from 'axios';
import { SERVER_ROUTE } from '../routes/api/api_routes';

const CoachParcours = () => {
    const dispatch = useDispatch();
    const parcoursList = useSelector(state => state.parcours.parcoursList);
    const domainesList = useSelector(state => state.domaines.domainesList);
    const [newParcours, setNewParcours] = useState({ name: '', domaine: '' });
    const [editingParcours, setEditingParcours] = useState(null);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState('');

    // Fetch parcours and domaines on mount
    useEffect(() => {
        if (!parcoursList || parcoursList.length === 0 || !domainesList || domainesList.length === 0) {
            ReduxAxios.all.getAllData();
        }
    }, []);

    // Add or update parcours handler
    const handleParcoursSubmit = async (e) => {
        e.preventDefault();
        if (!newParcours.name.trim() || !newParcours.domaine) {
            setError('Le nom et le domaine du parcours sont requis.');
            return;
        }
        setLoading(true);
        setError('');
        try {
            const token = localStorage.getItem('access');
            if (editingParcours) {
                await axios.put(
                    `${SERVER_ROUTE}/api/v1/parcours/${editingParcours.id}/`,
                    newParcours,
                    {
                        headers: {
                            'Content-Type': 'application/json',
                            'Authorization': `JWT ${token}`,
                            'Accept': 'application/json',
                        },
                    }
                );
            } else {
                await axios.post(
                    `${SERVER_ROUTE}/api/v1/parcours/`,
                    newParcours,
                    {
                        headers: {
                            'Content-Type': 'application/json',
                            'Authorization': `JWT ${token}`,
                            'Accept': 'application/json',
                        },
                    }
                );
            }
            ReduxAxios.all.getAllData();
            setNewParcours({ name: '', domaine: '' });
            setEditingParcours(null);
        } catch (err) {
            setError("Erreur lors de l'enregistrement du parcours.");
        } finally {
            setLoading(false);
        }
    };

    // Edit handler
    const handleEdit = (parcours) => {
        setEditingParcours(parcours);
        setNewParcours({ name: parcours.name, domaine: parcours.domaine });
    };

    // Delete handler
    const handleDelete = async (id) => {
        if (!window.confirm('Supprimer ce parcours ?')) return;
        setLoading(true);
        setError('');
        try {
            const token = localStorage.getItem('access');
            await axios.delete(`${SERVER_ROUTE}/api/v1/parcours/${id}/`, {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `JWT ${token}`,
                    'Accept': 'application/json',
                },
            });
            ReduxAxios.all.getAllData();
        } catch (err) {
            setError("Erreur lors de la suppression du parcours.");
        } finally {
            setLoading(false);
        }
    };

    // Cancel edit
    const handleCancelEdit = () => {
        setEditingParcours(null);
        setNewParcours({ name: '', domaine: '' });
        setError('');
    };

    return (
        <div style={{ minHeight: '100vh', background: '#fff' }}>
            <Navbar />
            <div style={{ padding: 32, maxWidth: 800, margin: '0 auto' }}>
                <h1 style={{ fontWeight: 800, fontSize: 36, marginBottom: 32 }}>Gérer les Parcours</h1>
                {/* Parcours Management Card */}
                <div style={{
                    background: 'linear-gradient(135deg, #00796b 0%, #009688 100%)',
                    borderRadius: 32,
                    padding: '32px 24px',
                    marginBottom: 40,
                    boxShadow: '0 8px 32px rgba(0,0,0,0.10)',
                    color: '#fff',
                }}>
                    <h2 style={{ fontWeight: 700, fontSize: 28, marginBottom: 24 }}>{editingParcours ? 'Modifier le Parcours' : 'Ajouter un Parcours'}</h2>
                    <form onSubmit={handleParcoursSubmit} style={{ display: 'flex', gap: 16, marginBottom: 24, flexWrap: 'wrap' }}>
                        <input
                            type="text"
                            value={newParcours.name}
                            onChange={e => setNewParcours({ ...newParcours, name: e.target.value })}
                            placeholder="Nom du parcours"
                            style={{
                                borderRadius: 12,
                                border: 'none',
                                padding: '12px 20px',
                                fontSize: 18,
                                width: 220,
                                outline: 'none',
                            }}
                        />
                        <select
                            value={newParcours.domaine}
                            onChange={e => setNewParcours({ ...newParcours, domaine: e.target.value })}
                            style={{
                                borderRadius: 12,
                                border: 'none',
                                padding: '12px 20px',
                                fontSize: 18,
                                width: 220,
                                outline: 'none',
                            }}
                        >
                            <option value="">Sélectionner un domaine</option>
                            {domainesList && domainesList.map(d => (
                                <option key={d.id} value={d.id}>{d.name}</option>
                            ))}
                        </select>
                        <button
                            type="submit"
                            style={{
                                background: '#FFA000',
                                color: '#fff',
                                fontWeight: 700,
                                fontSize: 18,
                                border: 'none',
                                borderRadius: 12,
                                padding: '12px 32px',
                                cursor: 'pointer',
                            }}
                            disabled={loading}
                        >
                            {loading ? (editingParcours ? 'Modification...' : 'Ajout...') : (editingParcours ? 'Modifier' : 'Ajouter')}
                        </button>
                        {editingParcours && (
                            <button
                                type="button"
                                onClick={handleCancelEdit}
                                style={{
                                    background: '#fff',
                                    color: '#009688',
                                    fontWeight: 700,
                                    fontSize: 18,
                                    border: '2px solid #009688',
                                    borderRadius: 12,
                                    padding: '12px 32px',
                                    cursor: 'pointer',
                                }}
                            >
                                Annuler
                            </button>
                        )}
                    </form>
                    {error && <div style={{ color: '#FFD700', marginBottom: 16 }}>{error}</div>}
                    <div style={{ background: '#fff', borderRadius: 16, padding: 24, color: '#222' }}>
                        <h3 style={{ fontWeight: 700, fontSize: 22, marginBottom: 16 }}>Parcours existants</h3>
                        {parcoursList && parcoursList.length > 0 ? (
                            <ul style={{ listStyle: 'none', padding: 0, margin: 0 }}>
                                {parcoursList.map(p => (
                                    <li key={p.id} style={{
                                        padding: '10px 0',
                                        borderBottom: '1px solid #eee',
                                        fontSize: 18,
                                        fontWeight: 500,
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'space-between',
                                    }}>
                                        <span>{p.name} <span style={{ color: '#888', fontSize: 15 }}>({(domainesList.find(d => d.id === p.domaine)?.name) || 'N/A'})</span></span>
                                        <span>
                                            <button onClick={() => handleEdit(p)} style={{ marginRight: 12, background: '#FFA000', color: '#fff', border: 'none', borderRadius: 8, padding: '4px 16px', fontWeight: 600, cursor: 'pointer' }}>Editer</button>
                                            <button onClick={() => handleDelete(p.id)} style={{ background: '#fff', color: '#F44336', border: '2px solid #F44336', borderRadius: 8, padding: '4px 16px', fontWeight: 600, cursor: 'pointer' }}>Supprimer</button>
                                        </span>
                                    </li>
                                ))}
                            </ul>
                        ) : (
                            <div style={{ color: '#888' }}>Aucun parcours trouvé.</div>
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default CoachParcours; 